import i18next from "i18next";
import { DateTime, Duration } from "luxon";
import { API_DOMAIN, PROTOCOL } from "../globals";
import db from "../database/database";
import { infoLog } from "./logger";
import { LegacyProviderConfigDto } from "@docket/consumer-app-client-typescript-axios";

// Oh god why
// https://stackoverflow.com/questions/201323/how-can-i-validate-an-email-address-using-a-regular-expression
// http://emailregex.com/
export const emailRegex =
  // eslint-disable-next-line no-control-regex
  /(?:[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:(2(5[0-5]|[0-4][0-9])|1[0-9][0-9]|[1-9]?[0-9]))\.){3}(?:(2(5[0-5]|[0-4][0-9])|1[0-9][0-9]|[1-9]?[0-9])|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])/;

export const pdfViewer = "view_pdf?name=";
//let embed = "https://docs.google.com/gview?embedded=true&url="

export const userPinAttempts = "userPinAttempts";
export const userPinAllowedDate = "userPinAllowedDate";

export const androidImmunizationsFaqPdfURL = `${PROTOCOL}://${API_DOMAIN}/${pdfViewer}Docket_Immunizations_FAQs_Overview.pdf`;
export const androidImmunizationsMultiMatchPdfURL = `${PROTOCOL}://${API_DOMAIN}/${pdfViewer}Docket_Immunizations_MULTI_MATCH_Help.pdf`;
export const androidImmunizationsNoMatchPdfURL = `${PROTOCOL}://${API_DOMAIN}/${pdfViewer}Docket_Immunizations_NO_MATCH_Help.pdf`;
export const androidImmunizationsUtahPinHelpPdfURL = `${PROTOCOL}://${API_DOMAIN}/${pdfViewer}Docket_Utah_PIN_Help.pdf`;
export const androidImmunizationsNJPrivacyPdfURL = `${PROTOCOL}://${API_DOMAIN}/${pdfViewer}NJ_Privacy_Notice.pdf`;

export const immunizationsFaqPdfURL = `${PROTOCOL}://${API_DOMAIN}/Docket_Immunizations_FAQs_Overview.pdf`;
export const immunizationsMultiMatchPdfURL = `${PROTOCOL}://${API_DOMAIN}/Docket_Immunizations_MULTI_MATCH_Help.pdf`;
export const immunizationsNoMatchPdfURL = `${PROTOCOL}://${API_DOMAIN}/Docket_Immunizations_NO_MATCH_Help.pdf`;
export const immunizationsUtahPinHelpPdfURL = `${PROTOCOL}://${API_DOMAIN}/Docket_Utah_PIN_Help.pdf`;
export const immunizationsNJPrivacyPdfURL = `${PROTOCOL}://${API_DOMAIN}/NJ_Privacy_Notice.pdf`;
export const docketPrivacyPdfURL = `${PROTOCOL}://${API_DOMAIN}/privacy_policy`;
export const docketTOSPdfURL = `${PROTOCOL}://${API_DOMAIN}/terms_of_use`;

export const virusFullNames = [
  "COVID-19",
  "Hepatitis B",
  "Rotavirus",
  "Diphtheria, Tetanus, Pertussis",
  "Haemophilus influenzae B",
  "Pneumococcal",
  "Polio",
  "Influenza",
  "Measles, Mumps, Rubella",
  "Varicella (Chickenpox)",
  "Hepatitis A",
  "Human Papillomavirus (HPV)",
  "Meningococcal",
  "Meningococcal B",
  "Zoster (Shingles)",
  "Yellow Fever",
  "Typhoid",
  "Monkeypox",
];

export const avatars: Map<number, string> = new Map([
  [1, "/assets/images/Blue_Alien.png"],
  [2, "/assets/images/Blue_Atom.png"],
  [3, "/assets/images/Blue_Cactus.png"],
  [4, "/assets/images/Blue_Campfire.png"],
  [5, "/assets/images/Blue_Dino.png"],
  [6, "/assets/images/Blue_Duck_Yellow.png"],
  [7, "/assets/images/Blue_Duck.png"],
  [8, "/assets/images/Blue_Matterhorn.png"],
  [9, "/assets/images/Blue_Tape.png"],
  [10, "/assets/images/Blue_Unicorn.png"],
  [11, "/assets/images/Blue_Vinyl.png"],
  [12, "/assets/images/Green_Alien.png"],
  [13, "/assets/images/Green_Atom.png"],
  [14, "/assets/images/Green_Cactus.png"],
  [15, "/assets/images/Green_Campfire.png"],
  [16, "/assets/images/Green_Dino.png"],
  [17, "/assets/images/Green_Duck_Yellow.png"],
  [18, "/assets/images/Green_Duck.png"],
  [19, "/assets/images/Green_Matterhorn.png"],
  [20, "/assets/images/Green_Tape.png"],
  [21, "/assets/images/Green_Unicorn.png"],
  [22, "/assets/images/Green_Vinyl.png"],
  [23, "/assets/images/Orange_Alien.png"],
  [24, "/assets/images/Orange_Atom.png"],
  [25, "/assets/images/Orange_Cactus.png"],
  [26, "/assets/images/Orange_Campfire.png"],
  [27, "/assets/images/Orange_Dino.png"],
  [28, "/assets/images/Orange_Duck_Yellow.png"],
  [29, "/assets/images/Orange_Duck.png"],
  [30, "/assets/images/Orange_Matterhorn.png"],
  [31, "/assets/images/Orange_Tape.png"],
  [32, "/assets/images/Orange_Unicorn.png"],
  [33, "/assets/images/Orange_Vinyl.png"],
  [34, "/assets/images/Pink_Alien.png"],
  [35, "/assets/images/Pink_Atom.png"],
  [36, "/assets/images/Pink_Cactus.png"],
  [37, "/assets/images/Pink_Campfire.png"],
  [38, "/assets/images/Pink_Dino.png"],
  [39, "/assets/images/Pink_Duck_Yellow.png"],
  [40, "/assets/images/Pink_Duck.png"],
  [41, "/assets/images/Pink_Matterhorn.png"],
  [42, "/assets/images/Pink_Tape.png"],
  [43, "/assets/images/Pink_Unicorn.png"],
  [44, "/assets/images/Pink_Vinyl.png"],
  [45, "/assets/images/Purple_Alien.png"],
  [46, "/assets/images/Purple_Atom.png"],
  [47, "/assets/images/Purple_Cactus.png"],
  [48, "/assets/images/Purple_Campfire.png"],
  [49, "/assets/images/Purple_Dino.png"],
  [50, "/assets/images/Purple_Duck_Yellow.png"],
  [51, "/assets/images/Purple_Duck.png"],
  [52, "/assets/images/Purple_Matterhorn.png"],
  [53, "/assets/images/Purple_Tape.png"],
  [54, "/assets/images/Purple_Unicorn.png"],
  [55, "/assets/images/Purple_Vinyl.png"],
  [56, "/assets/images/Yellow_Alien.png"],
  [57, "/assets/images/Yellow_Atom.png"],
  [58, "/assets/images/Yellow_Cactus.png"],
  [59, "/assets/images/Yellow_Campfire.png"],
  [60, "/assets/images/Yellow_Dino.png"],
  [62, "/assets/images/Yellow_Duck.png"],
  [63, "/assets/images/Yellow_Matterhorn.png"],
  [64, "/assets/images/Yellow_Tape.png"],
  [65, "/assets/images/Yellow_Unicorn.png"],
  [66, "/assets/images/Yellow_Vinyl.png"],
  [67, "/assets/images/JL_Avatar_1.png"],
  [68, "/assets/images/JL_Avatar_2.png"],
  [69, "/assets/images/JL_Avatar_3.png"],
  [70, "/assets/images/JL_Avatar_4.png"],
  [71, "/assets/images/JL_Avatar_5.png"],
  [72, "/assets/images/JL_Avatar_6.png"],
  [73, "/assets/images/JL_Avatar_7.png"],
  [74, "/assets/images/JL_Avatar_8.png"],
  [75, "/assets/images/JL_Avatar_9.png"],
  [76, "/assets/images/JL_Avatar_10.png"],
  [77, "/assets/images/JL_Avatar_11.png"],
  [78, "/assets/images/JL_Avatar_12.png"],
  [79, "/assets/images/JL_Avatar_13.png"],
  [80, "/assets/images/JL_Avatar_14.png"],
  [81, "/assets/images/JL_Avatar_15.png"],
  [82, "/assets/images/JL_Avatar_16.png"],
  [83, "/assets/images/JL_Avatar_17.png"],
  [84, "/assets/images/JL_Avatar_18.png"],
  [85, "/assets/images/JL_Avatar_19.png"],
  [86, "/assets/images/JL_Avatar_20.png"],
  [87, "/assets/images/JL_Avatar_21.png"],
  [88, "/assets/images/JL_Avatar_22.png"],
  [89, "/assets/images/JL_Avatar_23.png"],
  [90, "/assets/images/JL_Avatar_24.png"],
  [91, "/assets/images/JL_Avatar_25.png"],
  [92, "/assets/images/JL_Avatar_26.png"],
  [93, "/assets/images/JL_Avatar_27.png"],
  [94, "/assets/images/JL_Avatar_28.png"],
  [95, "/assets/images/JL_Avatar_29.png"],
  [96, "/assets/images/JL_Avatar_30.png"],
  [97, "/assets/images/JL_Avatar_31.png"],
  [98, "/assets/images/JL_Avatar_32.png"],
  [99, "/assets/images/JL_Avatar_33.png"],
  [100, "/assets/images/JL_Avatar_34.png"],
  [101, "/assets/images/JL_Avatar_35.png"],
  [102, "/assets/images/JL_Avatar_36.png"],
  [103, "/assets/images/JL_Avatar_37.png"],
  [104, "/assets/images/JL_Avatar_38.png"],
  [105, "/assets/images/JL_Avatar_39.png"],
  [106, "/assets/images/JL_Avatar_40.png"],
]);

export const setPinAllowedDate = async (date: string) => {
  await db().setItem(userPinAllowedDate, date);
};

export const getPinAllowedDate = async () => {
  return (await db().getItem(userPinAllowedDate)) ?? null;
};

export const setPinAttempts = async (reset: boolean) => {
  const attempts = await getPinAttempts();
  infoLog(`pin attempts ${attempts}`);
  await db().setItem(userPinAttempts, reset ? 0 : attempts + 1);
};

export const getPinAttempts = async () => {
  const value: number | null = await db().getItem(userPinAttempts);
  const parsed = value ? value : 0;
  return parsed;
};

export const sortApiConfigAscending = (
  config: LegacyProviderConfigDto[]
): LegacyProviderConfigDto[] => {
  if (config) {
    return config.sort(function (a, b) {
      let textA = a.iz_provider.destination_id.toUpperCase();
      let textB = b.iz_provider.destination_id.toUpperCase();
      return textA < textB ? -1 : textA > textB ? 1 : 0;
    });
  }
  return [] as LegacyProviderConfigDto[];
};

export const formatNumber = (pn: string) => {
  if (pn.length === 10) {
    return `(${pn.slice(0, 3)}) ${pn.slice(3, 6)}-${pn.slice(6)}`;
  }
  // potentially malformed or intl number
  return pn;
};

export const pwdCheck = (pwd: string) => {
  if (pwd.length < 8) {
    return "At least eight (8) characters long, please!";
  } else if (pwd.length > 50) {
    return "No more than fifty (50) characters, please!";
  } else {
    let totalMatches = 0;
    totalMatches += /[a-z]/.test(pwd) ? 1 : 0; // lower
    totalMatches += /[A-Z]/.test(pwd) ? 1 : 0; // upper
    totalMatches += /[0-9]/.test(pwd) ? 1 : 0; // number
    totalMatches += /[^a-zA-Z0-9]/.test(pwd) ? 1 : 0; // symbol
    if (totalMatches >= 2) {
      return "";
    }
    return "Passwords must be 8+ characters and contain at least 1: uppercase, number, or special character!";
  }
};

// Luxon doesn't really have a way to parse multiple formats at once when
// we don't know the format ahead of time and the PWA seems to swap between
// ISO and locale format depending on input source.
export const getDateTime = (date: string): DateTime<true> | DateTime<false> => {
  let dateTime = DateTime.fromISO(date);
  if (!dateTime.isValid) {
    dateTime = DateTime.fromFormat(date, "MM/dd/yyyy");

    if (!dateTime.isValid) {
      dateTime = DateTime.fromFormat(date, "M/dd/yyyy");
    }

    if (!dateTime.isValid) {
      dateTime = DateTime.fromFormat(date, "M/d/yyyy");
    }
  }

  return dateTime;
};

export const readableDate = (date: number | Date | string) => {
  if (date instanceof Date) {
    return DateTime.fromJSDate(date).toISODate() ?? "";
  } else if (typeof date === "number") {
    return DateTime.fromMillis(date).toISODate() ?? "";
  }
  return getDateTime(date).toISODate() ?? "";
};

export const getWaitTimeText = (waitTime: number) => {
  if (waitTime > 600 || waitTime < 1) {
    return "...";
  }
  return Duration.fromObject({
    seconds: waitTime < 60 ? waitTime : undefined,
    minutes: waitTime >= 60 && waitTime <= 600 ? Math.ceil(waitTime / 60) : undefined,
  }).toHuman();
};
